import { render, staticRenderFns } from "./PartImage.vue?vue&type=template&id=3a70caf2&scoped=true"
import script from "./PartImage.vue?vue&type=script&lang=js"
export * from "./PartImage.vue?vue&type=script&lang=js"
import style0 from "./PartImage.vue?vue&type=style&index=0&id=3a70caf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a70caf2",
  null
  
)

export default component.exports